import {
  BitkitFilter,
  IconCheckCircle,
  IconCrossCircle,
  IconErrorCircle,
  IconSkipCircle,
  IconWarning,
} from '@bitrise/bitkit-v2';

import { TestFilter, TestFilters, TestSummary } from '../TestResults.types';

const getStatusItems = (summary: TestSummary) => [
  { icon: IconCrossCircle, iconColor: 'icon/negative' as const, label: `Failed (${summary.failed})`, value: 'failed' },
  { icon: IconCheckCircle, iconColor: 'icon/positive' as const, label: `Passed (${summary.passed})`, value: 'passed' },
  { icon: IconSkipCircle, label: `Skipped (${summary.skipped})`, value: 'skipped' },
  { icon: IconErrorCircle, iconColor: 'icon/negative' as const, label: `Error (${summary.error})`, value: 'error' },
  { icon: IconWarning, iconColor: 'icon/warning' as const, label: `Flaky (${summary.flaky})`, value: 'flaky' },
];

type Props = {
  filters: TestFilters;
  onSearchChange: (search: string) => void;
  onStatusChange: (status: TestFilter) => void;
  summary: TestSummary;
};

const TestsHeader = ({ filters, onSearchChange, onStatusChange, summary }: Props) => (
  <BitkitFilter
    borderBlockEndWidth="1"
    borderColor="border/minimal"
    marginBlockStart="-16"
    paddingBlock="12"
    paddingInline="8"
    showClear={false}
  >
    <BitkitFilter.Switch
      allLabel={`All tests (${summary.all})`}
      items={getStatusItems(summary)}
      label="Status"
      onValueChange={(status) => onStatusChange((status ?? 'all') as TestFilter)}
      value={filters.status === 'all' ? null : filters.status}
    />
    <BitkitFilter.Search onValueChange={onSearchChange} value={filters.search} />
  </BitkitFilter>
);

export default TestsHeader;
